<template>
  <div class="gj-upload" :class="{'gj-upload-cannot-delete': !deletable}">
    <el-upload
        ref="gjUploadAttach"
        v-bind="$attrs"
        v-on="$listeners"
        :disabled="disabled"
        :before-upload="proxyBeforeUpload"
        :http-request="customUpload"
        :file-list="proxyFileList"
        :show-file-list="false"
        action="">
      <slot>
        <gj-button type="text"><i v-if="isIcon" class="iconfont iconenclosure size12"></i>{{text}}</gj-button>
      </slot>
    </el-upload>
  </div>
</template>

<script>
  import {downloadAttFile, removeAttachmentById, uploadFile} from "../../api/common";
  import {isMeaningfulMixin} from "../../minxins";
  import {isMeaningful} from "../../utils/common";

  export default {
    name: "gj-upload-attach",
    mixins: [isMeaningfulMixin],
    props: {
      text: {
        type: String,
        default: '上传附件'
      },
      deletable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      isIcon: {
        type: Boolean,
        default: false,
      },
      acceptType: {
        type: Array,
        default: () => {
          return [];
        }
      },
      containerType: {
        type: String,
        default: '',
      },
      containerBizId: {
        default: null
      },
      fileList: {
        type: Array,
        default: () => []
      },
      beforeUpload: {
        type: Function,
        default: null
      },
      //是否上传文件列表变动时，删除已上传的 被移除的文件
      noRemove:{
        type:Boolean,
        default: false
      }
    },
    watch: {
      fileList: {
        deep: true,  // 深度监听
        handler(newVal, oldVal) {
          this.proxyFileList = newVal;
          if (isMeaningful(oldVal) && isMeaningful(newVal) && oldVal.length > newVal.length && !this.noRemove) {
            const newIds = newVal.map(v => v.attId);
            this.removeFile(oldVal.filter(v => newIds.indexOf(v.attId) === -1)[0].attId)
          }
        }
      }
    },
    created() {
      this.proxyFileList = this.fileList;
    },
    data() {
      return {
        proxyFileList: [],
        loading: false,
      }
    },
    methods: {
      proxyBeforeUpload(file) {
        if (this.beforeUpload) {
          const valid = this.beforeUpload(file);
          if (!valid) {
            return false;
          }
        }
        if (this.acceptType.length > 0 && this.acceptType.indexOf(file.type) === -1) {
          this.$gjMessage.error('无法接受的文件类型');
          return false;
        }
        return true;
      },
      customUpload(data) {
        let formData = new FormData();
        formData.append('file', data.file);
        formData.append('bizType', this.containerType);
        formData.append('bizId', this.containerBizId);
        uploadFile(formData)
          .then((res) => {
            if (res.code === 0) {
              this.proxyFileList.push({attId: res.data.id, name: data.file.name});
              this.$emit('update:fileList', this.proxyFileList);
            } else {
              this.$gjMessage.error('上传文件失败，请稍后再试');
            }
          });
      },
      removeFile(attId) {
        if (isMeaningful(attId)) {
          removeAttachmentById(attId)
            .then(() => {

            });
        }
      },
    }
  }
</script>

<style scoped>
  .gj-upload div:first-child {
    display: inline-block;
  }

  .gj-image-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
  }

  .gj-image-uploader /deep/ .el-upload:hover {
    border-color: #1F6EEF;
  }

  /deep/ .el-upload-list__item-name {
    padding-left: 0;
  }
  .gj-upload-cannot-delete /deep/ .el-icon-close-tip,
  .gj-upload-cannot-delete /deep/ .el-icon-close,
  .gj-upload-cannot-delete /deep/ .el-upload-list__item-status-label {
    display: none;
  }
</style>
